import { AccountType } from "@common/constants/domains/accounting/accounts";
import { collectSubtreeGroupIds } from "./draftGroupOperations";
import { AllocateCodeText, DraftAccount, DraftState } from "./draftState";

export const retypeGroupSubtrees = ({
    state,
    rootGroupIds,
    targetType,
    allocateCodeText,
    initialScanAccounts,
}: {
    state: DraftState;
    rootGroupIds: string[];
    targetType: AccountType;
    allocateCodeText: AllocateCodeText;
    initialScanAccounts: DraftAccount[];
}): {
    descendantGroupIds: Set<string>;
    codeByAccountId: Map<string, string | null>;
} => {
    const allSubtreeIds = new Set<string>();
    for (const rootId of rootGroupIds) {
        for (const id of collectSubtreeGroupIds(rootId, state.groups)) {
            allSubtreeIds.add(id);
        }
    }
    const rootSet = new Set(rootGroupIds);
    const descendantGroupIds = new Set<string>();
    for (const id of allSubtreeIds) {
        if (!rootSet.has(id)) {
            descendantGroupIds.add(id);
        }
    }

    const codeByAccountId = new Map<string, string | null>();
    let scanAccounts = initialScanAccounts;
    for (const account of state.accounts) {
        if (
            account.parentGroupId != null &&
            allSubtreeIds.has(account.parentGroupId) &&
            account.type !== targetType
        ) {
            const codeText = allocateCodeText({
                kind: "relocate",
                type: targetType,
                accounts: scanAccounts,
                currentCodeText: account.codeText,
            });
            codeByAccountId.set(account.id, codeText);
            scanAccounts = scanAccounts.map((row) =>
                row.id === account.id ? { ...row, codeText } : row,
            );
        }
    }
    return { descendantGroupIds, codeByAccountId };
};
